var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",staticStyle:{"height":"100%"}},[_c('personOrderCalendar',{ref:"personOrder",attrs:{"applet-data":_vm.appletData},on:{"viewObject":_vm.viewObject,"addNewForm":_vm.addnew}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }